/*!
 * Jarallax v2.0.4 (https://github.com/nk-o/jarallax)
 * Copyright 2022 nK <https://nkdev.info>
 * Licensed under MIT (https://github.com/nk-o/jarallax/blob/master/LICENSE)
 */ !(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : ((e =
        "undefined" != typeof globalThis ? globalThis : e || self).jarallax =
        t());
})(this, function () {
  "use strict";
  function e(e) {
    "complete" === document.readyState || "interactive" === document.readyState
      ? e()
      : document.addEventListener("DOMContentLoaded", e, {
          capture: !0,
          once: !0,
          passive: !0,
        });
  }
  let t;
  var i = (t =
    "undefined" != typeof window
      ? window
      : "undefined" != typeof global
      ? global
      : "undefined" != typeof self
      ? self
      : {});
  let { navigator: o } = i,
    n = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      o.userAgent
    ),
    a,
    s;
  function l() {
    s = n
      ? (!a &&
          document.body &&
          (((a = document.createElement("div")).style.cssText =
            "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;"),
          document.body.appendChild(a)),
        (a ? a.clientHeight : 0) ||
          i.innerHeight ||
          document.documentElement.clientHeight)
      : i.innerHeight || document.documentElement.clientHeight;
  }
  l(),
    i.addEventListener("resize", l),
    i.addEventListener("orientationchange", l),
    i.addEventListener("load", l),
    e(() => {
      l();
    });
  let r = [];
  function p() {
    r.length &&
      (r.forEach((e, t) => {
        let { instance: o, oldData: n } = e,
          a = o.$item.getBoundingClientRect(),
          l = {
            width: a.width,
            height: a.height,
            top: a.top,
            bottom: a.bottom,
            wndW: i.innerWidth,
            wndH: s,
          },
          p =
            !n ||
            n.wndW !== l.wndW ||
            n.wndH !== l.wndH ||
            n.width !== l.width ||
            n.height !== l.height,
          m = p || !n || n.top !== l.top || n.bottom !== l.bottom;
        (r[t].oldData = l), p && o.onResize(), m && o.onScroll();
      }),
      i.requestAnimationFrame(p));
  }
  let m = 0;
  class d {
    constructor(e, t) {
      let i = this;
      (i.instanceID = m),
        (m += 1),
        (i.$item = e),
        (i.defaults = {
          type: "scroll",
          speed: 0.8,
          imgSrc: null,
          imgElement: ".jarallax-img",
          imgSize: "cover",
          imgPosition: "50% 50%",
          imgRepeat: "no-repeat",
          keepImg: !1,
          elementInViewport: null,
          zIndex: -100,
          disableParallax: !1,
          disableVideo: !1,
          videoSrc: null,
          videoStartTime: 0,
          videoEndTime: 0,
          videoVolume: 0,
          videoLoop: !0,
          videoPlayOnlyVisible: !0,
          videoLazyLoading: !0,
          onScroll: null,
          onInit: null,
          onDestroy: null,
          onCoverImage: null,
        });
      let n = i.$item.dataset || {},
        a = {};
      if (
        (Object.keys(n).forEach((e) => {
          let t = e.substr(0, 1).toLowerCase() + e.substr(1);
          t && void 0 !== i.defaults[t] && (a[t] = n[e]);
        }),
        (i.options = i.extend({}, i.defaults, a, t)),
        (i.pureOptions = i.extend({}, i.options)),
        Object.keys(i.options).forEach((e) => {
          "true" === i.options[e]
            ? (i.options[e] = !0)
            : "false" === i.options[e] && (i.options[e] = !1);
        }),
        (i.options.speed = Math.min(
          2,
          Math.max(-1, parseFloat(i.options.speed))
        )),
        "string" == typeof i.options.disableParallax &&
          (i.options.disableParallax = RegExp(i.options.disableParallax)),
        i.options.disableParallax instanceof RegExp)
      ) {
        let s = i.options.disableParallax;
        i.options.disableParallax = () => s.test(o.userAgent);
      }
      if (
        ("function" != typeof i.options.disableParallax &&
          (i.options.disableParallax = () => !1),
        "string" == typeof i.options.disableVideo &&
          (i.options.disableVideo = RegExp(i.options.disableVideo)),
        i.options.disableVideo instanceof RegExp)
      ) {
        let l = i.options.disableVideo;
        i.options.disableVideo = () => l.test(o.userAgent);
      }
      "function" != typeof i.options.disableVideo &&
        (i.options.disableVideo = () => !1);
      let r = i.options.elementInViewport;
      r && "object" == typeof r && void 0 !== r.length && ([r] = r),
        r instanceof Element || (r = null),
        (i.options.elementInViewport = r),
        (i.image = {
          src: i.options.imgSrc || null,
          $container: null,
          useImgTag: !1,
          position: "fixed",
        }),
        i.initImg() && i.canInitParallax() && i.init();
    }
    css(e, t) {
      return "string" == typeof t
        ? i.getComputedStyle(e).getPropertyValue(t)
        : (Object.keys(t).forEach((i) => {
            e.style[i] = t[i];
          }),
          e);
    }
    extend(e, ...t) {
      return (
        (e = e || {}),
        Object.keys(t).forEach((i) => {
          t[i] &&
            Object.keys(t[i]).forEach((o) => {
              e[o] = t[i][o];
            });
        }),
        e
      );
    }
    getWindowData() {
      return {
        width: i.innerWidth || document.documentElement.clientWidth,
        height: s,
        y: document.documentElement.scrollTop,
      };
    }
    initImg() {
      let e = this,
        t = e.options.imgElement;
      return (
        t && "string" == typeof t && (t = e.$item.querySelector(t)),
        t instanceof Element ||
          (e.options.imgSrc
            ? ((t = new Image()).src = e.options.imgSrc)
            : (t = null)),
        t &&
          (e.options.keepImg
            ? (e.image.$item = t.cloneNode(!0))
            : ((e.image.$item = t), (e.image.$itemParent = t.parentNode)),
          (e.image.useImgTag = !0)),
        !!e.image.$item ||
          (null === e.image.src &&
            ((e.image.src =
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
            (e.image.bgImage = e.css(e.$item, "background-image"))),
          !(!e.image.bgImage || "none" === e.image.bgImage))
      );
    }
    canInitParallax() {
      return !this.options.disableParallax();
    }
    init() {
      let e = this,
        t = {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
        },
        o = {
          pointerEvents: "none",
          transformStyle: "preserve-3d",
          backfaceVisibility: "hidden",
        };
      if (!e.options.keepImg) {
        let n = e.$item.getAttribute("style");
        if (
          (n && e.$item.setAttribute("data-jarallax-original-styles", n),
          e.image.useImgTag)
        ) {
          let a = e.image.$item.getAttribute("style");
          a && e.image.$item.setAttribute("data-jarallax-original-styles", a);
        }
      }
      if (
        ("static" === e.css(e.$item, "position") &&
          e.css(e.$item, { position: "relative" }),
        "auto" === e.css(e.$item, "z-index") && e.css(e.$item, { zIndex: 0 }),
        (e.image.$container = document.createElement("div")),
        e.css(e.image.$container, t),
        e.css(e.image.$container, { "z-index": e.options.zIndex }),
        "fixed" === this.image.position &&
          e.css(e.image.$container, {
            "-webkit-clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          }),
        e.image.$container.setAttribute(
          "id",
          `jarallax-container-${e.instanceID}`
        ),
        e.$item.appendChild(e.image.$container),
        e.image.useImgTag
          ? (o = e.extend(
              {
                "object-fit": e.options.imgSize,
                "object-position": e.options.imgPosition,
                "max-width": "none",
              },
              t,
              o
            ))
          : ((e.image.$item = document.createElement("div")),
            e.image.src &&
              (o = e.extend(
                {
                  "background-position": e.options.imgPosition,
                  "background-size": e.options.imgSize,
                  "background-repeat": e.options.imgRepeat,
                  "background-image":
                    e.image.bgImage || `url("${e.image.src}")`,
                },
                t,
                o
              ))),
        ("opacity" === e.options.type ||
          "scale" === e.options.type ||
          "scale-opacity" === e.options.type ||
          1 === e.options.speed) &&
          (e.image.position = "absolute"),
        "fixed" === e.image.position)
      ) {
        let s = (function e(t) {
          let i = [];
          for (; null !== t.parentElement; )
            1 === (t = t.parentElement).nodeType && i.push(t);
          return i;
        })(e.$item).filter((e) => {
          let t = i.getComputedStyle(e),
            o = t["-webkit-transform"] || t["-moz-transform"] || t.transform;
          return (
            (o && "none" !== o) ||
            /(auto|scroll)/.test(t.overflow + t["overflow-y"] + t["overflow-x"])
          );
        });
        e.image.position = s.length ? "absolute" : "fixed";
      }
      (o.position = e.image.position),
        e.css(e.image.$item, o),
        e.image.$container.appendChild(e.image.$item),
        e.onResize(),
        e.onScroll(!0),
        e.options.onInit && e.options.onInit.call(e),
        "none" !== e.css(e.$item, "background-image") &&
          e.css(e.$item, { "background-image": "none" }),
        e.addToParallaxList();
    }
    addToParallaxList() {
      r.push({ instance: this }), 1 === r.length && i.requestAnimationFrame(p);
    }
    removeFromParallaxList() {
      let e = this;
      r.forEach((t, i) => {
        t.instance.instanceID === e.instanceID && r.splice(i, 1);
      });
    }
    destroy() {
      this.removeFromParallaxList();
      let e = this.$item.getAttribute("data-jarallax-original-styles");
      if (
        (this.$item.removeAttribute("data-jarallax-original-styles"),
        e
          ? this.$item.setAttribute("style", e)
          : this.$item.removeAttribute("style"),
        this.image.useImgTag)
      ) {
        let t = this.image.$item.getAttribute("data-jarallax-original-styles");
        this.image.$item.removeAttribute("data-jarallax-original-styles"),
          t
            ? this.image.$item.setAttribute("style", e)
            : this.image.$item.removeAttribute("style"),
          this.image.$itemParent &&
            this.image.$itemParent.appendChild(this.image.$item);
      }
      this.image.$container &&
        this.image.$container.parentNode.removeChild(this.image.$container),
        this.options.onDestroy && this.options.onDestroy.call(this),
        delete this.$item.jarallax;
    }
    clipContainer() {}
    coverImage() {
      let e = this,
        t = e.image.$container.getBoundingClientRect(),
        i = t.height,
        { speed: o } = e.options,
        n = "scroll" === e.options.type || "scroll-opacity" === e.options.type,
        a = 0,
        l = i,
        r = 0;
      return (
        n &&
          (0 > o
            ? ((a = o * Math.max(i, s)), s < i && (a -= o * (i - s)))
            : (a = o * (i + s)),
          1 < o
            ? (l = Math.abs(a - s))
            : 0 > o
            ? (l = a / o + Math.abs(a))
            : (l += (s - i) * (1 - o)),
          (a /= 2)),
        (e.parallaxScrollDistance = a),
        (r = n ? (s - l) / 2 : (i - l) / 2),
        e.css(e.image.$item, {
          height: `${l}px`,
          marginTop: `${r}px`,
          left: "fixed" === e.image.position ? `${t.left}px` : "0",
          width: `${t.width}px`,
        }),
        e.options.onCoverImage && e.options.onCoverImage.call(e),
        { image: { height: l, marginTop: r }, container: t }
      );
    }
    isVisible() {
      return this.isElementInViewport || !1;
    }
    onScroll(e) {
      let t = this,
        o = t.$item.getBoundingClientRect(),
        n = o.top,
        a = o.height,
        l = {},
        r = o;
      if (
        (t.options.elementInViewport &&
          (r = t.options.elementInViewport.getBoundingClientRect()),
        (t.isElementInViewport =
          0 <= r.bottom &&
          0 <= r.right &&
          r.top <= s &&
          r.left <= i.innerWidth),
        !e && !t.isElementInViewport)
      )
        return;
      let p = Math.max(0, a + n),
        m = Math.max(0, -n),
        d = Math.max(0, n + a - s),
        c = Math.max(0, a - (n + a - s)),
        g = Math.max(0, -n + s - a),
        u = 1 - 2 * ((s - n) / (s + a)),
        h = 1;
      if (
        (a < s
          ? (h = 1 - (m || d) / a)
          : p <= s
          ? (h = p / s)
          : c <= s && (h = c / s),
        ("opacity" === t.options.type ||
          "scale-opacity" === t.options.type ||
          "scroll-opacity" === t.options.type) &&
          ((l.transform = "translate3d(0,0,0)"), (l.opacity = h)),
        "scale" === t.options.type || "scale-opacity" === t.options.type)
      ) {
        let f = 1;
        0 > t.options.speed
          ? (f -= t.options.speed * h)
          : (f += t.options.speed * (1 - h)),
          (l.transform = `scale(${f}) translate3d(0,0,0)`);
      }
      if ("scroll" === t.options.type || "scroll-opacity" === t.options.type) {
        let y = t.parallaxScrollDistance * u;
        "absolute" === t.image.position && (y -= n),
          (l.transform = `translate3d(0,${y}px,0)`);
      }
      t.css(t.image.$item, l),
        t.options.onScroll &&
          t.options.onScroll.call(t, {
            section: o,
            beforeTop: Math.max(0, n),
            beforeTopEnd: p,
            afterTop: m,
            beforeBottom: d,
            beforeBottomEnd: c,
            afterBottom: g,
            visiblePercent: h,
            fromViewportCenter: u,
          });
    }
    onResize() {
      this.coverImage();
    }
  }
  let c = function (e, t, ...i) {
    ("object" == typeof HTMLElement
      ? e instanceof HTMLElement
      : e &&
        "object" == typeof e &&
        null !== e &&
        1 === e.nodeType &&
        "string" == typeof e.nodeName) && (e = [e]);
    let o = e.length,
      n = 0,
      a;
    for (; n < o; n += 1)
      if (
        ("object" == typeof t || void 0 === t
          ? e[n].jarallax || (e[n].jarallax = new d(e[n], t))
          : e[n].jarallax && (a = e[n].jarallax[t].apply(e[n].jarallax, i)),
        void 0 !== a)
      )
        return a;
    return e;
  };
  c.constructor = d;
  let g = i.jQuery;
  if (void 0 !== g) {
    let u = function (...e) {
      Array.prototype.unshift.call(e, this);
      let t = c.apply(i, e);
      return "object" != typeof t ? t : this;
    };
    u.constructor = c.constructor;
    let h = g.fn.jarallax;
    (g.fn.jarallax = u),
      (g.fn.jarallax.noConflict = function () {
        return (g.fn.jarallax = h), this;
      });
  }
  return (
    e(() => {
      c(document.querySelectorAll("[data-jarallax]"));
    }),
    c
  );
});
